import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';



export class EntityInChargeView extends Component {

	render() {
		const { cfcuContractManager, deuaSectorExpert, deuaMonitoringExpert, eudSectorManager, beneficiaryInstitution, contractingPartner } = this.props;
		return (
			<Card>
				<CardHeader title="Entity In Charge" className='romis-card-header' />
				<CardContent>
					<TextField
						label="CFCU Contract Manager :"
						value={cfcuContractManager}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}


					/>

					<TextField
						label="DEAU Sector Expert :"
						value={deuaSectorExpert}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}


					/>
					<TextField
						label="DEAU Monitoring Expert :"
						value={deuaMonitoringExpert}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}

					/>
					<TextField
						label="EU Sector Manager :"
						value={eudSectorManager}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}

					/>
					<TextField
						label="Beneficiary Institution :"
						value={beneficiaryInstitution}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}


					/>
					<TextField
						label="Contracting Partner :"
						value={contractingPartner}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}


					/>
				</CardContent>

			</Card>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/EntityInChargeView.js